import { DestroyRef, ErrorHandler, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { filter } from 'rxjs';
import { GtmEventServiceService } from './gtm-event-service.service';

@Injectable({ providedIn: 'root' })
export class FunnelTrackingService {
  private readonly router = inject(Router);
  private readonly gtmEventService = inject(GtmEventServiceService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly errorHandler = inject(ErrorHandler);
  private started = false;
  private previousStep: string | undefined;

  start(): void {
    if (this.started) return;
    this.started = true;

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.trackCurrentStep());

    if (this.router.navigated) this.trackCurrentStep();
  }

  private trackCurrentStep(): void {
    const stepName = this.getCurrentStepPath();
    if (stepName === this.previousStep) return;
    this.previousStep = stepName;

    if (stepName) {
      void this.gtmEventService
        .pushEvent('funnel_step', { step_name: stepName })
        .catch((error: unknown) => this.errorHandler.handleError(error));
    }
  }

  private getCurrentStepPath(): string | undefined {
    let route = this.router.routerState.snapshot.root;
    let child = route.children.find(candidate => candidate.outlet === PRIMARY_OUTLET);

    while (child) {
      route = child;
      child = route.children.find(candidate => candidate.outlet === PRIMARY_OUTLET);
    }

    return route.routeConfig?.data?.['funnelStep'] === true ? route.routeConfig.path : undefined;
  }
}
